const { Loader } = require('google-maps');
import { mapStyles } from 'Utils/MapStyles';
import HTTP from 'Utils/HTTP';

class LocationMap {
	locations = [];
	mapMarkers = [];
	mapInfoWindows = [];

	radius = 75;

	iconPathSmall = '/typo3conf/ext/dts_core/Resources/Public/Images/map/pin-small.svg';
	iconPathBig = '/typo3conf/ext/dts_core/Resources/Public/Images/map/pin-big.svg';
	iconPathHQSmall = '/typo3conf/ext/dts_core/Resources/Public/Images/map/pin-hq-small.svg';
	iconPathHQBig = '/typo3conf/ext/dts_core/Resources/Public/Images/map/pin-hq-big.svg';
	iconPathWhere = '/typo3conf/ext/dts_core/Resources/Public/Images/map/pin-where.svg';

	replaceRegex = new RegExp(`(###)([^###]*)(###)`, 'g');
	replaceRegex2 = new RegExp(`//(###)([^###]*)(###)`, 'g');

	constructor() {
		this.root = document.querySelector('.js-locationMap');

		this.onClickResultItem = ::this.onClickResultItem;
		this.onCountryCheckboxChange = ::this.onCountryCheckboxChange;
		this.onHeadquarterCheckboxChange = ::this.onHeadquarterCheckboxChange;

		this.radius = this.root.dataset.radius || this.radius;

		this.mapMarkerUrl = this.root.dataset.mapMarkerUrl;
		this.mapContainer = this.root.querySelector('.js-mapContainer');

		this.searchForm = this.root.querySelector('.js-locationMapForm');
		this.searchInput = this.root.querySelector('.js-locationSearchInput');

		this.resultsList = this.root.querySelector('.js-locationMapResultsList');
		this.nearestLocationTemplate = this.root.querySelector('.js-locationMapNearest');
		this.infoTemplate = this.root.querySelector('.js-infoWindow');

		this.noResults = this.root.querySelector('.js-noResults');
		this.noResults.innerHTML = this.noResults.innerHTML.replace('|RADIUS|', this.radius);

		this.searchForm.addEventListener('submit', ::this.onSubmitSearchForm);

		this.countryCheckboxes = Array.from(
			this.root.querySelectorAll('.js-locationMapCountryCheckbox')
		);
		this.countryCheckboxes.forEach(checkbox => {
			checkbox.addEventListener('click', this.onCountryCheckboxChange);
		});

		this.headquartersCheckboxes = Array.from(
			this.root.querySelectorAll('.js-locationMapHeadquarterCheckbox')
		);
		this.headquartersCheckboxes.forEach(checkbox => {
			checkbox.addEventListener('click', this.onHeadquarterCheckboxChange);
		});

		this.loadGoogle();
	}

	async loadGoogle() {
		const loader = new Loader(this.root.dataset.apiKey, {
			language: document.documentElement.lang,
		});

		this.google = await loader.load();

		const geocoder = new this.google.maps.Geocoder();

		this.map = new this.google.maps.Map(this.mapContainer, {
			options: {
				fullscreenControl: false,
				mapTypeControl: false,
				streetViewControl: false,
			},
			styles: mapStyles,
		});

		this.circle = new this.google.maps.Circle({
			map: this.map,
			radius: this.radius * 1000,
			clickable: false,
			fillColor: '#fff',
			fillOpacity: 0,
			strokeColor: '#313131',
			strokeOpacity: 0,
			strokeWeight: 0.8,
		});

		this.addCircleContainsLocationMethod();

		this.loadMarkers();
	}

	addCircleContainsLocationMethod() {
		this.google.maps.Circle.prototype.containsLocation = latLng =>
			this.circle.getBounds().contains(latLng) &&
			this.google.maps.geometry.spherical.computeDistanceBetween(this.circle.getCenter(), latLng) <=
				this.circle.getRadius();
	}

	loadMarkers() {
		HTTP.get(this.mapMarkerUrl).then(response => {
			if (response.status === 200 && response.data) {
				const { success, locations, focusedLocation } = response.data;
				if (success) {
					this.locations = locations;
					this.focusedLocation = focusedLocation;
					this.placeMarkers();
				}
			}
		});
	}

	placeMarkers(selectiveLocations = null, avoidFocus = false, onlyPlacePins = false) {
		this.mapMarkers.forEach(marker => {
			marker.setMap(null);
		});
		this.mapMarkers = [];
		let focusedMarker;

		const bounds = new this.google.maps.LatLngBounds();

		const locations = selectiveLocations || this.locations;

		locations.forEach((location, i) => {
			this.setMarker(location, i);
			this.setInfoWindow(location);
			bounds.extend(
				new this.google.maps.LatLng({
					lat: parseFloat(location.lat),
					lng: parseFloat(location.lng),
				})
			);
			if (location.uid === this.focusedLocation) {
				focusedMarker = i;
			}
		});

		if (!onlyPlacePins && focusedMarker != null && !avoidFocus) {
			const geocoder = new this.google.maps.Geocoder();

			this.map.fitBounds(bounds);

			this.searchForLoaction(locations[focusedMarker].zip + '+' + locations[focusedMarker].city);
			if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
				setTimeout(() => {
					this.map.panBy(-170, 0);
				}, 250);
			}

			this.google.maps.event.trigger(this.mapMarkers[focusedMarker], 'click');
		}

		if (!onlyPlacePins && this.focusedLocation === 0) {
			this.map.fitBounds(bounds);
			setTimeout(() => {
				this.map.fitBounds(bounds);
			}, 100);
		}
	}

	setMarker(location, i) {
		const position = this.getCoords(location);
		const mapMarker = new this.google.maps.Marker({
			position,
			icon: {
				url: location.headquarter ? this.iconPathHQSmall : this.iconPathSmall,
				scaledSize: new this.google.maps.Size(20, 27),
				headquarter: location.headquarter,
			},
			map: this.map,
			title: location.name,
			uid: location.uid,
		});

		this.mapMarkers.push(mapMarker);

		mapMarker.addListener('click', e => {
			this.closeAllMarkers();

			const index = this.locations.findIndex(loc => loc.uid === location.uid);

			const marker = this.mapMarkers.find(marker => marker.uid === location.uid);

			marker.setIcon({
				url: location.headquarter ? this.iconPathHQBig : this.iconPathBig,
				scaledSize: new this.google.maps.Size(40, 54),
				headquarter: location.headquarter,
			});

			this.currentInfoWindowOpen = index;
			this.mapInfoWindows[index].open(this.map, marker);
		});
	}

	closeAllMarkers() {
		this.mapMarkers.forEach(marker => {
			const icon = marker.getIcon();
			marker.setIcon({
				url: icon.headquarter ? this.iconPathHQSmall : this.iconPathSmall,
				scaledSize: new this.google.maps.Size(20, 27),
				headquarter: icon.headquarter,
			});
		});

		if (this.currentInfoWindowOpen != null) {
			this.mapInfoWindows[this.currentInfoWindowOpen] &&
				this.mapInfoWindows[this.currentInfoWindowOpen].close();
		}
	}

	setInfoWindow(marker) {
		const template = this.createDOM(this.infoTemplate, marker);

		const mapInfoWindow = new this.google.maps.InfoWindow({
			content: template,
		});

		this.mapInfoWindows.push(mapInfoWindow);
	}

	getCoords(location) {
		return { lat: +location.lat, lng: +location.lng };
	}

	onSubmitSearchForm(e) {
		e.preventDefault();

		this.placeMarkers(null, true);
		this.searchForLoaction(this.searchInput.value, true);
	}

	searchForLoaction(location, panToLocation = false) {
		if (this.currentSearch === location || location === '') return;
		this.currentSearch = location;

		const geocoder = new this.google.maps.Geocoder();

		geocoder.geocode({ address: this.currentSearch }, (results, status) => {
			this.searchInput.classList.remove('is-invalid');

			switch (status) {
				case this.google.maps.GeocoderStatus.OK: {
					const firstResult = results[0];
					const pos = {
						lat: firstResult.geometry.location.lat(),
						lng: firstResult.geometry.location.lng(),
					};
					panToLocation && this.changeLocation(pos);
					this.circle.setCenter(pos);
					this.findClosestMarker(pos);
					this.listClosest(pos);
					break;
				}
				default: {
					this.searchInput.classList.add('is-invalid');
				}
			}
		});
	}

	changeLocation(pos) {
		if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
			this.panToWithOffset(pos, -100, 0);
		} else {
			this.panToWithOffset(pos, 0, 0);
		}
		this.setCurrentMarker(pos);
	}

	panToWithOffset(latlng, offsetX, offsetY) {
		this.map.panTo(latlng);
		this.map.setZoom(9);
		this.map.panBy(offsetX, offsetY);
	}

	findClosestMarker(pos) {
		if (!pos || !this.mapMarkers.length === 0) return;
		this.closest = null;

		this.mapMarkers.forEach(marker => {
			const markerLatLng = marker.getPosition();
			const posLatLng = new this.google.maps.LatLng(pos);

			if (markerLatLng.lat() === 0 && isNaN(markerLatLng.lng)) return;

			const distance = this.google.maps.geometry.spherical.computeDistanceBetween(
				markerLatLng,
				posLatLng
			);

			if (!this.closest || this.closest.distance > distance) {
				this.closest = { marker, distance };
			}
		});

		if (this.closest) {
			const isInRadius = this.closest.distance <= this.radius * 1000;
			let timeout = 0;
			let timeout2 = 0;

			if (!isInRadius) {
				timeout = 1000;

				const bounds = new this.google.maps.LatLngBounds();

				bounds.extend(this.closest.marker.getPosition());
				bounds.extend(new this.google.maps.LatLng(pos));

				this.map.fitBounds(bounds);
			}

			setTimeout(() => {
				this.google.maps.event.trigger(this.closest.marker, 'click');
			}, timeout);
		}
	}

	listClosest(pos) {
		Array.from(this.root.querySelectorAll('.js-locationMapNearestButton')).forEach(item =>
			item.removeEventListener('click', this.onClickResultItem)
		);
		this.resultsList.innerHTML = '';

		const results = [];
		let resultCount = 0;

		this.mapMarkers.forEach((marker, i) => {
			const isInRadius = this.circle.containsLocation(marker.getPosition());

			if (isInRadius) {
				const posLatLng = new this.google.maps.LatLng(pos);
				const md = this.google.maps.geometry.spherical.computeDistanceBetween(
					marker.getPosition(),
					posLatLng
				);

				const template = this.createDOM(this.nearestLocationTemplate, this.locations[i]);
				template.addEventListener('click', this.onClickResultItem);
				template.setAttribute('data-marker', i);
				if (this.closest.distance === md) template.classList.add('active');

				results.push({ md, template });

				resultCount++;
			}
		});

		results.sort((a, b) => a.md - b.md);

		results.forEach(res => {
			this.resultsList.appendChild(res.template);
		});

		if (resultCount >= 1) {
			this.noResults.classList.add('hidden');
		} else {
			this.noResults.classList.remove('hidden');
		}
	}

	onClickResultItem = ({ currentTarget: target }) => {
		Array.from(this.root.querySelectorAll('.js-locationMapNearest')).forEach(item =>
			item.classList.remove('active')
		);
		target.classList.add('active');

		const markerId = +target.getAttribute('data-marker');
		const marker = this.mapMarkers[markerId];
		this.google.maps.event.trigger(marker, 'click');

		if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
			this.panToWithOffset(marker.position, -100, 0);
		} else {
			this.panToWithOffset(marker.position, 0, 0);
		}
	};

	setCurrentMarker(position) {
		this.unsetCurrentMarker();

		this.currentSearchMarker = new this.google.maps.Marker({
			position,
			animation: this.google.maps.Animation.DROP,
			icon: this.iconPathWhere,
			map: this.map,
		});
	}

	unsetCurrentMarker() {
		if (this.currentSearchMarker) {
			this.currentSearchMarker.setMap(null);
			this.currentSearchMarker = null;
		}
	}

	createDOM(el, marker) {
		const template = el.cloneNode(true);
		template.classList.remove('hidden');
		const values = Array.from(template.querySelectorAll('.js-value'));
		values.forEach(val => {
			const inner = val.innerHTML;
			const key = inner.split('###')[1];
			let newVal = marker[key];

			if (newVal) {
				if (key === 'www' && !newVal.includes('www')) {
					newVal = `/${newVal}`;
				}

				val.innerHTML = inner.replace(this.replaceRegex, newVal);

				if (key === 'www' && !newVal.includes('www')) {
					val.innerHTML = val.innerHTML.replace('//', '');
				}
			} else {
				if (key === 'headquarterLabel' && marker.headquarter && marker.company?.label) {
					val.innerHTML = inner.replace(this.replaceRegex, marker.company.label);
				} else {
					val.classList.add('hidden');
				}
			}
		});

		const link = template.querySelector('.js-link');
		if (link) {
			link.href = marker.detailpageLink.link;
			if (marker.detailpageLink.target !== '') {
				link.setAttribute('target', marker.detailpageLink.target);
			} else {
				link.removeAttribute('target');
			}

			if (marker.detailpageLink.title !== '') {
				link.innerText = marker.detailpageLink.title;
			} else {
				link.innerText = link.dataset.defaultLabel;
			}
		}

		return template;
	}

	onCountryCheckboxChange(e) {
		const geocoder = new this.google.maps.Geocoder();
		this.placeMarkers(null, true, true);

		geocoder.geocode({ address: e.currentTarget.value }, (results, status) => {
			if (status === this.google.maps.GeocoderStatus.OK) {
				this.map.setCenter(results[0].geometry.location);
				this.map.fitBounds(results[0].geometry.viewport);
			}
		});

		if (this.currentInfoWindowOpen != null) {
			this.mapInfoWindows[this.currentInfoWindowOpen] &&
				this.mapInfoWindows[this.currentInfoWindowOpen].close();
		}
	}

	onHeadquarterCheckboxChange(e) {
		const id = +e.currentTarget.value;
		const targetLocations = this.locations.filter(location => location?.company?.uid === id);

		this.placeMarkers(targetLocations, true);

		this.map.setZoom(Math.min(this.map.getZoom(), 8));
	}
}

new LocationMap();
